<template>

  <div class="row" ref="virtualCourseForm">
    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <card>
          <div slot="header">
            <h4 class="card-title">
              {{ formTitle }}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-6">
                    <ValidationProvider
                      vid="title"
                      rules="required"
                      name="The Title"
                      v-slot="{ passed, failed,errors }">
                      <fg-input type="text"
                                :error="failed ? errors[0]: null"
                                label="Title"
                                name="title"
                                fou
                                @keyup="generateSomeFields"
                                v-model="formData.title">
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      vid="url"
                      rules="required"
                      name="The URL"
                      v-slot="{ passed, failed,errors }">
                      <fg-input type="text"
                                :error="failed ? errors[0]: null"
                                label="URL"
                                name="url"
                                fou
                                v-model="formData.url">
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
                <ValidationProvider
                  vid="forum"
                  rules="required"
                  name="The Edition"
                  v-slot="{ passed, failed,errors }">
                  <fg-select
                    name="forum_id"
                    size="large"
                    filterable
                    clearable
                    placeholder="Edition"
                    :error="failed ? errors[0]: null"
                    :input-classes="'select-default'"
                    :label="'Edition'"
                    :list="builderData.forumList"
                    :listItemLabel="'name'"
                    :listItemValue="'id'"
                    v-model="formData.forum_id">
                  </fg-select>
                </ValidationProvider>
                <div class="row">
                  <div class="col-md-12">
                    <label>Dates</label>
                    <div class="col-12">
                      <template class="row" v-for="(listItem,listItemIndex) in formData.dates">
                        <label>Item # {{ listItemIndex + 1 }}</label>
                        <div class="row team_list_items">
                          <!--                list item from date-->
                          <div class="col-md-6">
                            <label class="card-label">From Date</label>
                            <ValidationProvider
                              vid="en.datesfrom"
                              rules="required"
                              name="The From Date"
                              v-slot="{ passed, failed,errors }">
                              <fg-input v-model="formData.dates[listItemIndex].from_date"
                                        :error="failed ? errors[0]: null"
                                        value-format="YYYY-MM-DD HH:MM:SS"
                                        type="datetime-local"
                                        placeholder="From Date"
                              >
                              </fg-input>
                            </ValidationProvider>
                          </div>
                          <!--                list item to date-->
                          <div class="col-md-6">
                            <label class="card-label">To Date</label>
                            <ValidationProvider
                              vid="en.datesto"
                              rules="required"
                              name="The To Date"
                              v-slot="{ passed, failed,errors }">
                              <fg-input v-model="formData.dates[listItemIndex].to_date"
                                        :error="failed ? errors[0]: null"
                                        value-format="YYYY-MM-DD HH:MM:SS"
                                        type="datetime-local"
                                        placeholder="To Date"
                              >
                              </fg-input>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-sm-1 align-self-center mt-3">
                          <l-button
                            @click="removeItem(formData.dates, listItemIndex)"
                            type="danger" size="sm">
                            <i class="fa fa-trash"></i>
                          </l-button>
                        </div>
                      </template>
                      <l-button
                        class="mt-3"
                        type="success"
                        @click="addNewItem(formData.dates, { from_date: '', to_date: ''})"
                        size="sm">
                        <i class="fa fa-plus"></i>
                      </l-button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Content</label>
                  <editor
                    v-model="formData.content"
                    :api-key="editorKey"
                    :init='editorConfig'
                  />
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>Notes</label>
                    <div class="col-12">
                      <template class="row" v-for="(listItem,listItemIndex) in formData.notes">
                        <div class="row team_list_items">
                          <label>Item # {{ listItemIndex + 1 }}</label>
                          <div class="col-md-12">
                            <ValidationProvider
                              vid="title"
                              rules="required"
                              name="The Title"
                              v-slot="{ passed, failed,errors }">
                              <fg-input type="text"
                                        :error="failed ? errors[0]: null"
                                        label="Title"
                                        name="title"
                                        fou
                                        v-model="formData.notes[listItemIndex].title">
                              </fg-input>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-sm-1 align-self-center mt-3">
                          <l-button
                            @click="removeItem(formData.notes, listItemIndex)"
                            type="danger" size="sm">
                            <i class="fa fa-trash"></i>
                          </l-button>
                        </div>
                      </template>
                      <l-button
                        class="mt-3"
                        type="success"
                        @click="addNewItem(formData.notes, { title: ''})"
                        size="sm">
                        <i class="fa fa-plus"></i>
                      </l-button>
                    </div>
                  </div>
                </div>
                <div class="form-group pt-4">
                  <label>Is Active</label>&nbsp;
                  <l-switch v-model="formData.is_active">
                    <i class="fa fa-check" slot="on"></i>
                    <i class="fa fa-times" slot="off"></i>
                  </l-switch>
                </div>
            </div>
          </div>
          </div>
          <div class="card-footer text-right">
            <l-button :disabled="entityNotFoundError || submitting" @click.prevent="handleSubmit(submit)"
                      nativeType="submit"
                      type="info" wide>Submit
            </l-button>
            <l-button @click="$router.push('/virtual-courses/list')" type="danger" wide>Cancel
            </l-button>
          </div>
        </card>

      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import {Option, Select, Tooltip} from "element-ui";
import FgSelect from "@/components/Inputs/formGroupSelect";
import FormGroupTextArea, {ImageUploader, PrimeUploader, PrimeVideoUploader, Switch as LSwitch} from "@/components";
import Editor from '@tinymce/tinymce-vue'



extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    PrimeUploader,
    FormGroupTextArea,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    FgSelect,
    LSwitch,
    'editor': Editor
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,
      editorConfig: this.getEditorConfig(),
      editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {
        title: "",
        url: "",
        dates: [{from_date: '', to_date: ''}],
        content: "",
        notes: [],
        is_active: true,
        forum_id: '',
      },
      builderData: {
        forumList: [],
      },
      currentEditedFormData:{
        forum_id: '',
      }

    };
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.virtualCourseForm
    });

    let data = {}
    this.axios.post("virtual-courses/builder", data).then((response) => {
      this.builderData.forumList = response.data.forums;
      this.formData.forum_id = response.data.currentForum ? response.data.currentForum.id : null;


      this.id = this.$route.params['id'];

      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Virtual Course";
        this.getItem();
      } else {
        this.editMode = false;
        this.formTitle = "Add Virtual Course";
        this.loader.hide();
      }
    }).catch((error) => {
      console.error(error);
    })
  },
  methods: {
    getItem() {
      let data = {
        'id': this.id,
      };
      this.axios.post("virtual-courses/get", data).then((response) => {
        this.formData = response.data;
        this.currentEditedFormData.forum_id = this.formData.forum_id;
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Virtual Course Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;
      if (this.editMode === true) {
        request = this.axios.put("virtual-courses/update/" + this.id, this.formData);
        successMessage = "Virtual Course Updated Successfully";
      } else {
        request = this.axios.post("virtual-courses/create", this.formData);
        successMessage = "Virtual Course Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/virtual-courses/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    generateSomeFields() {
      let newUrl = '';
      if (this.formData.title) {
        newUrl = this.formData.title.replace(/\s+/g, "-").toLowerCase();
        newUrl = newUrl.replace(/[^ءأ-يa-zA-Z0-9-]/g, "");
        newUrl = newUrl.replace(/([-]+)/g, "-");
      }
      this.formData.url = newUrl;
    },
    addNewItem(listItems, initObject) {
      listItems.push(initObject);
    },
    removeItem(listItems, index) {
      listItems.splice(index, 1);
    },
  }
}
</script>
